import React, { useMemo, useState, useEffect, Fragment } from "react";
import ReactDOM from "react-dom";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DefaultButton from "../components/CustomComponents/DefaultButton";
import { Box } from "@mui/material";
import { Divider } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Terms from "../PatientLogin/Terms";
import Popover from "@mui/material/Popover";
import { set } from "lodash";

export default function PrivacyPolicy({ terms }) {
    // console.log("sessionStorage", sessionStorage.getItem("termsAccepted"));
    // const terms_condition = JSON.parse(terms);

    const [termsCondition, setTermsCondition] = useState("");

    useEffect(() => {
        fetch('/user/getTermsAndCondition')
            .then(response => response.text())
            .then(data => {
                setTermsCondition(data);
            })
            .catch(error => console.error('Error:', error));
    }, []);

    const [open, setOpen] = useState(false);
    const [openTerms, setOpenTerms] = useState(false);
    const privacyPolicyUrl = window.location.origin + "/sh-data-privacy";

    const onClose = () => {
        if (reason === "backdropClick") {
            return;
        }
        setOpen(false);
    };

    const onAccept = () => {
        sessionStorage.setItem("termsAccepted", "true");
        setOpen(false);
    };

    const termsOfUseLink = () => {
        return (
            <Link
                href="#"
                onClick={() => {
                    setOpenTerms(true);
                }}
            >
                Terms of Use
            </Link>
        );
    };

    const privacyPolicyLink = () => {
        return (
            <Link
                href="#"
                onClick={() => {
                    window.open(privacyPolicyUrl, "_blank");
                }}
            >
                Privacy Policy
            </Link>
        );
    };

    const handleCloseTermsOfUse = () => {
        setOpenTerms(false);
    };

    useEffect(() => {
        const accepted = sessionStorage.getItem("termsAccepted");
        if (!accepted) {
            setOpen(true);
        }

        window.openReactDialog = () => setOpenTerms(true);
    }, []);

    const [anchorPosition, setAnchorPosition] = useState(null);
    const [isHovering, setIsHovering] = useState(false);

    const handleEnter = (event) => {
        console.log("hover in");
        console.log("window.innerHeight", window.innerHeight);             
        setIsHovering(true);
        setAnchorPosition({
            top: window.innerHeight < 950 ? 50 : 755,
            left: 250,
        });
    };

    const handleLeave = () => {
        console.log("hover out");
        setIsHovering(false);
        setTimeout(() => {
            if (!isHovering) {
                setAnchorPosition(null);
            }
        }, 100);
    };

    const handlePopoverEnter = () => {
        console.log("popover hover in");
        setIsHovering(true);
    };

    const handlePopoverLeave = () => {
        console.log("popover hover out");
        setIsHovering(false);
        setAnchorPosition(null);
    };

    return (
        <>
            <Dialog
                fullWidth={true}
                maxWidth="xl"
                open={open}
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: { md: "95vw", xs: "80vw" },
                        maxWidth: "2000px",
                        paddingBottom: "0px",
                    },
                }}
                sx={{
                    "& .MuiDialog-container": {
                        alignItems: "flex-end",
                        justifyContent: "center",
                    },
                    "& .MuiPaper-root": {
                        margin: 0,
                        mb: 2,
                    },
                }}
            >
                <DialogContent
                    sx={{
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        paddingLeft: "5px",
                        paddingRight: "20px",
                    }}
                >
                    <Grid
                        container
                        spacing={1}
                        sx={{
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Grid
                            item
                            container
                            spacing={2}
                            xs={12}
                            lg={12}
                            xl={11}
                        >
                            <Grid item xs="auto">
                                <Box
                                    id="logo-img"
                                    component="img"
                                    sx={{
                                        maxHeight: "100px",
                                        maxWidth: "100px",
                                    }}
                                    src="/images/sh/CORSealFinal.png"
                                    onMouseEnter={handleEnter}
                                    onMouseLeave={handleLeave}
                                    onClick={handleEnter}
                                />
                            </Grid>
                            <Grid
                                item
                                sx={{
                                    "@media (max-width:2560px)": {
                                        paddingLeft: "30px !important",
                                    },
                                }}
                                xs={12}
                                md={10.5}
                            >
                                <Typography
                                    variant="h6"
                                    gutterBottom
                                    sx={{
                                        marginTop: {
                                            md: "20px !important",
                                            sx: "0px !important",
                                        },
                                        maxWidth: "1400px !important",
                                    }}
                                >
                                    We are committed to protecting your personal
                                    information. By continuing to access this
                                    website, you acknowledge that you have read
                                    and agreed to our {termsOfUseLink()} and{" "}
                                    {privacyPolicyLink()}.
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            container
                            sx={{
                                justifyContent: "center",
                                // paddingTop: "0px !important",
                            }}
                            xs={12}
                            lg={12}
                            xl={1}
                        >
                            <DefaultButton
                                id="accept-btn"
                                label="I ACCEPT"
                                variant="contained"
                                onClick={onAccept}
                                sx={{
                                    height: { md: "50px", xs: "40px" },
                                    width: { md: "160px", xs: "110px" },
                                }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                {/* Preview pop-up */}
                <Popover
                    open={Boolean(anchorPosition)}
                    anchorReference="anchorPosition"
                    anchorPosition={anchorPosition}
                    onClose={() => setAnchorPosition(null)}
                    disableRestoreFocus
                    transformOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                    }}
                    slotProps={{
                        paper: {
                            // onMouseEnter: handlePopoverEnter,
                            // onMouseLeave: handlePopoverLeave,
                            sx: { p: 0 },
                        },
                    }}
                >
                    <Box
                        id="preview-img"
                        component="img"
                        src="/images/sh/CORSeal2Final.png"
                        alt="Large preview"
                        sx={{
                            maxWidth: { md: "400px", xs: "200px" },
                            height: "auto",
                            display: "block",
                        }}
                    />
                </Popover>
            </Dialog>
            <Terms
                open={openTerms}
                title="Terms of Use"
                content={termsCondition}
                onClose={handleCloseTermsOfUse}
            />
        </>
    );
}

if (document.getElementById("privacy-policy")) {
    var terms = document.getElementById("privacy-policy").getAttribute("terms");
    ReactDOM.render(
        <PrivacyPolicy terms={terms} />,
        document.getElementById("privacy-policy")
    );
}
